// eslint-disable-next-line no-useless-escape
const sanitizeRegex = new RegExp(/[&\/\\#,+()$~%.'":*?<>{}]/g)

export default sanitizeRegex
